const TOKEN_STORAGE_KEY = 'chekin-token';
const GUEST_TOKEN_STORAGE_KEY = 'guest-token';

const NONE_EXEMPTION = 'NONE';
const LS_I18NEXT_LNG_KEY = 'i18nextLng';

/**
 * @internal
 */
enum FIELD_TYPES {
  text = 'TEXT',
  date = 'DATE',
  file = 'FILE',
  time = 'TIME',
  select = 'SELECT',
  phone = 'PHONE',
}

const DATE_FORMAT = 'YYYY-MM-DD';

const ORIGINS = {
  guestApp: 'GUEST_APP',
  guestAppV2: 'GUEST_APP_V2',
  embeddedGuestApp: 'EMBEDDED_GUEST_APP',
  avantio: 'AVANTIO',
  guesty: 'GUESTY',
  guesty2: 'GUESTY_2',
};

enum PAYMENT_PROVIDERS {
  paycomet = 'PAYCOMET',
  stripe = 'STRIPE',
  addon = 'ADDON',
}

enum PAYMENTS_SETTINGS_STATUSES {
  new = 'NEW',
  validating = 'VALIDATING',
  valid = 'VALID',
  invalid = 'INVALID',
}

enum CURRENCIES {
  eur = 'eur',
  usd = 'usd',
  gbp = 'gbp',
  aed = 'aed',
  czk = 'czk',
  chf = 'chf',
}

enum IV_DOCUMENT_IMAGE_TYPES {
  front = 'front',
  back = 'back',
  selfie = 'selfie',
}

enum RESERVATION_PAYMENT_TYPES {
  upselling = 'UPSELLING',
  touristTaxes = 'TOURIST_TAXES',
  booking = 'BOOKING',
  pmsIntegration = 'PMS_INTEGRATION',
  extraService = 'EXTRA_SERVICE',
  damageProtection = 'DAMAGE_PROTECTION',
  securityDeposit = 'SECURITY_DEPOSIT',
  upsellingThirdParty = 'UPSELLING_3D_PARTY',
}

enum MULTI_PAYMENT_STEP_TYPES {
  paymentSetupConfirmation = 'PAYMENT_SETUP_CONFIRMATION',
  paymentSetupInit = 'PAYMENT_SETUP_INIT',
  taxesSetup = 'TAXES_SETUP',
}

enum MULTI_PAYMENT_STEP_STATUSES {
  inProgress = 'IN_PROGRESS',
  dataRequired = 'DATA_REQUIRED',
  error = 'ERROR',
  complete = 'COMPLETE',
  skipped = 'SKIPPED',
}

enum MULTI_PAYMENT_STATUSES {
  new = 'NEW',
  inProgress = 'IN_PROGRESS',
  failed = 'FAILED',
  complete = 'COMPLETE',
}

const WS_EVENT_TYPES = {
  multiPaymentUpdated: 'MULTI_PAYMENT_UPDATED',
  ivStartedOnMobile: 'IV_STARTED_ON_MOBILE',
  ivCompletedReturningToDesktop: 'IV_COMPLETED_RETURNING_TO_DESKTOP',
  ivCompletedContinuedOnMobile: 'IV_COMPLETED_CONTINUE_ON_MOBILE',
};

enum DAY_NAMES {
  monday = 'MON',
  tuesday = 'TUE',
  wednesday = 'WED',
  thursday = 'THU',
  friday = 'FRI',
  saturday = 'SAT',
  sunday = 'SUN',
}

enum PAYMENT_METHOD_TYPES {
  payOnline = 'PAY_ONLINE',
  payLater = 'PAY_LATER',
  payOnArrival = 'PAY_ON_ARRIVAL',
}

enum SUMMARY_PAYMENTS_STATUSES {
  configurationPending = 'CONFIGURATION_PENDING',
  readyForPayment = 'READY_FOR_PAYMENT',
  payOnArrival = 'PAY_ON_ARRIVAL',
  complete = 'COMPLETE',
  inactive = 'INACTIVE',
}

const POLICE_CODES = {
  nationalPolice: 'POL', // Disabled for Spain
  nat: 'NAT', // Disabled for Spain
  ertzaintza: 'ERT',
  mossos: 'MOS',
  isp: 'ISP',
  sef: 'SEF',
  sef2: 'SEF2',
  uhh: 'UHH', // Disabled police
  uhh2: 'UHH2',
  ubyPort: 'CUP',
  ubyPort2: 'CUP2',
  thai: 'THAI',
  feratel: 'FER',
  feratelGermany: 'FERG',
  capcorn: 'CAP', // Only for rendering in UI. It's Feratel. Take a look at getPreloadedPoliceType if you're going to remove it
  sloveniaAgency: 'AJP',
  stadtZurich: 'CHE',
  germanyAVS: 'AVS',
  fake: 'FAKE',
  cev: 'CEV',
  hospedajes: 'HOS',
};

enum SHORT_LINK_INSTANCE {
  unlockLink = 'UNLOCKLINK',
  reservation = 'RESERVATION',
  housing = 'HOUSING',
}

enum SHORT_LINK_TYPE {
  main = 'RESERVATION_SIGN_UP_FORM',
  payment = 'RESERVATION_PAYMENT',
  upselling = 'RESERVATION_UPSELLING',
  lock = 'RESERVATION_LOCK',
}

enum AUTH_INIT_MODELS {
  housing = 'Housing',
  user = 'User',
  reservation = 'Reservation',
}

export enum OFFER_STATUSES {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
}

export enum RESERVATION_SEARCH_MODE {
  bookingReference = 'BOOKING_REFERENCE',
  checkinEmail = 'CHECKIN_EMAIL',
  both = 'BOTH',
}

export enum RESERVATION_NOT_FOUND_BEHAVIOR {
  create = 'CREATE_IF_NOT_FOUND',
  doNotCreate = 'DO_NOT_CREATE_IF_NOT_FOUND',
}

export enum OAUTH_PROVIDER {
  google = 'google',
  apple = 'apple',
}

export enum ACCESS_TIME_STATUS {
  default = 'DEFAULT',
  disabled = 'DISABLED',
  custom = 'CUSTOM',
}

export {
  ORIGINS,
  TOKEN_STORAGE_KEY,
  LS_I18NEXT_LNG_KEY,
  DATE_FORMAT,
  FIELD_TYPES,
  PAYMENT_PROVIDERS,
  PAYMENTS_SETTINGS_STATUSES,
  CURRENCIES,
  RESERVATION_PAYMENT_TYPES,
  MULTI_PAYMENT_STEP_TYPES,
  MULTI_PAYMENT_STEP_STATUSES,
  WS_EVENT_TYPES,
  MULTI_PAYMENT_STATUSES,
  DAY_NAMES,
  PAYMENT_METHOD_TYPES,
  SUMMARY_PAYMENTS_STATUSES,
  NONE_EXEMPTION,
  POLICE_CODES,
  SHORT_LINK_INSTANCE,
  SHORT_LINK_TYPE,
  AUTH_INIT_MODELS,
  IV_DOCUMENT_IMAGE_TYPES,
  GUEST_TOKEN_STORAGE_KEY,
};
